export default __webpack_public_path__ + "static/media/print.695c9eb4.svg";